import styled from '@emotion/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import Icon from '../trash-simple.svg';

const ThemedTrashCan = styled(Icon)(() => {
    return {
        height: '24px',
        width: '24px',
        '& path': {
            stroke: colors.icons,
            strokeWidth: '3px',
        },
        '& line': {
            stroke: colors.icons,
        },
    };
});
const TrashCan: FC<React.SVGProps<SVGSVGElement>> = ({ ...rest }) => {
    return <ThemedTrashCan {...rest} />;
};

export default TrashCan;
